import { render, staticRenderFns } from "./Activation.vue?vue&type=template&id=0229b5c2&scoped=true&"
import script from "./Activation.vue?vue&type=script&lang=ts&"
export * from "./Activation.vue?vue&type=script&lang=ts&"
import style0 from "./Activation.vue?vue&type=style&index=0&id=0229b5c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0229b5c2",
  null
  
)

export default component.exports